import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { FrameworkEditor } from "@/components/admin/FrameworkEditor";
import { KonsepPanel } from "@/components/admin/KonsepPanel";
import { QuotaWeights } from "@/components/admin/QuotaWeights";
import { useApi } from "@/lib/api";
import { useMe } from "@/lib/me";
import { AdminNav } from "@/components/admin/AdminNav";

const ORDER = ["bdq", "skda", "hte", "kbm", "adab"];
const SHORT = { bdq: "BDQ", skda: "SKDA", hte: "HTE", kbm: "KBM", adab: "ADAB" };

export default function AdminKerangkaPage() {
  const api = useApi();
  const me = useMe();
  const [fws, setFws] = useState(null);
  useEffect(() => { if (me?.role === "superadmin") api("get", "/admin/frameworks").then(setFws).catch(() => setFws([])); }, [api, me]);
  if (me && me.role !== "superadmin") return <Navigate to="/" replace />;
  if (!me || !fws) return <div className="p-10"><Loader2 className="animate-spin text-q" /></div>;
  const replace = (f) => setFws(fws.map((x) => (x.id === f.id ? f : x)));
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-8 py-10 space-y-8" data-testid="admin-kerangka-page">
      <header>
        <AdminNav />
        <div className="eyebrow mt-6">Admin · superadmin</div>
        <h1 className="font-display text-4xl sm:text-5xl text-ink mt-3">Kerangka</h1>
        <p className="text-sm text-mute mt-3 max-w-2xl">Setiap simpanan menaikkan prompt_versi kerangka itu dan direkod dalam sejarah. Tahap yang masih "(belum ditetapkan)" kekal tidak aktif sehingga diisi.</p>
      </header>
      <Tabs defaultValue="hte">
        <TabsList className="flex flex-wrap h-auto">
          {ORDER.map((id) => <TabsTrigger key={id} value={id} data-testid={`fw-tab-${id}`}>{SHORT[id]}</TabsTrigger>)}
          <TabsTrigger value="kuota" data-testid="fw-tab-kuota">Kuota</TabsTrigger>
        </TabsList>
        {ORDER.map((id) => {
          const f = fws.find((x) => x.id === id);
          return (
            <TabsContent key={id} value={id} className="pt-6 space-y-10">
              {f && <FrameworkEditor initial={f} onSaved={replace} />}
              {id === "skda" && <KonsepPanel />}
              {id === "kbm" && <p className="text-xs text-mute">Muat naik templat modul DOCX akan tersedia bersama penjana KBM (Fasa 8).</p>}
            </TabsContent>
          );
        })}
        <TabsContent value="kuota" className="pt-6"><QuotaWeights /></TabsContent>
      </Tabs>
    </div>
  );
}
